// Before & After case studies — crawlable text (not just image galleries).
// Every case study is factual, disclaimer-bound and never claims we caused a grade.

export const CASE_STUDIES = [
  {
    id: "vintage-holo-surface-residue",
    title: "Vintage Holo with Surface Residue",
    category: "Pokémon · Vintage",
    before:
      "A vintage holofoil arrived with visible fingerprint residue and light surface film across the non-holo border, along with loose debris trapped near two corners. The card's underlying edges and corners were sharp, and no scratches or creases were present.",
    after:
      "After individual evaluation, the removable surface residue and debris were responsibly addressed. The border presented cleaner and the holo pattern read more clearly under light. No structural characteristics were altered — the corners and edges were exactly as they arrived.",
    note:
      "Surface residue was removable; structure was untouched. We made no claim about grade outcome — this card was returned to the collector to submit at their discretion.",
  },
  {
    id: "modern-chrome-haze",
    title: "Modern Chrome Refractor with Handling Haze",
    category: "Sports · Modern",
    before:
      "A modern chrome refractor showed handling haze and fingerprints across the front surface — common on chrome finishes — with no scratches, print lines or edge damage noted.",
    after:
      "The finish-appropriate surface care reduced the handling haze and removed fingerprints, allowing the refractor pattern to present more evenly. The card's edges, corners and centering were unchanged.",
    note:
      "Haze and fingerprints were surface-level and removable. Refractor pattern and card structure were factory-original and untouched.",
  },
  {
    id: "vintage-cardboard-preserve",
    title: "Vintage Cardboard — Preserved, Not Processed",
    category: "Baseball · Vintage",
    before:
      "A vintage baseball card arrived with soft corners, a light surface texture and decades of natural aging on porous cardboard stock.",
    after:
      "On evaluation, the responsible decision was minimal handling and preservation-minded packaging. Aggressive cleaning would have risked irreversible damage to fragile stock, and the card's character was part of its value.",
    note:
      "Not every card should be processed. Here the honest recommendation was preservation over cleaning — we returned the card stabilized and protected.",
  },
  {
    id: "comic-cover-debris",
    title: "Modern Comic Cover with Surface Debris",
    category: "Comics · Modern",
    before:
      "A modern glossy-cover comic showed surface debris and light smudging on the front cover, with a tight spine and no significant stress lines.",
    after:
      "Paper-appropriate surface care addressed the removable debris and smudging without stressing the spine or interior pages. The cover gloss presented more evenly.",
    note:
      "Comics are paper and much of their condition is permanent. Only removable surface debris was addressed; the spine and pages were handled conservatively.",
  },
];
